import React, { useEffect, useRef } from "react";

function ClickOutside(props) {
    const ref = useRef(null);
    const { onClickOutside, show, className } = props;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                onClickOutside && onClickOutside();
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [onClickOutside]);


    return (
        <>
            {show ? (
                <div ref={ref} className={className}>
                    {props.children}
                </div>
            ):(<></>)}

        </>
    )
}

export default ClickOutside;